module.exports = __webpack_public_path__ + "static/media/product-choice2.e8ae7a20.png";